export default class LocoSection {
    public name = ''
    public index = 0
    public code = ''
    public warningCount = 0
    public generatorEngineOn!: boolean
    public generatorEngineIdle!: boolean
}